import {
  Drawer,
  Typography,
  FormControl,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TPCheckbox from "../../../TemplateProperties/TPCheckbox";
import React, { useEffect, useState, useContext,useCallback} from "react";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import ItemPropertiesDelimiterInput from "../../../ItemProperties/ItemPropertiesDelimiterInput";
import CommonGrid from "../../../Repository/CommonGrid";
import ArrowForwardIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import { styled } from '@mui/material/styles';
import { CustomDropdownEditor } from "../QuickAddModal";
import { fieldTypeOptionsArray, outboundFieldTypeOptionsArray } from "../../../../constants/constantList";
import { api } from "../../../../redux/api";
import _ from 'lodash';

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}));
const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, .05)'
      : 'rgba(0, 0, 0, .03)',
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(270deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
}));


function CustomizeQuickFieldAdd({ open, setOpenCustomizeModal,setAvailableColumns,columns,handleCustomizePasteLogic, quickAddModal,tabData,setTabData,setPasteLogicUpdated }) {
  const drawerWidth = 450;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const parentScreen = useContext(ParentScreenCtx);
  const quickAdd = useSelector(
    (state) => state.treeData[parentScreen].quickAdd
  );
  const templateHeader = useSelector(
    (state) => state.treeData[parentScreen].rightTree.tree.templateHeader
  );
  const { currentScreen } = useSelector((state) => state.treeData);
  const [expanded, setExpanded] = useState("availableColumns");
  const [previouslyExpanded, setPreviouslyExpanded] = useState(null);

  const [recordDelimiterValue, setRecordDelimiterValue] = useState("");
  const [fieldDelimiterValue, setFieldDelimiterValue] = useState("");

  const [fieldTypeRowData, setFieldTypeRowData] = useState([]);

  const [fieldTypeGridApi, setFieldTypeGridApi] = useState(null);
  const [fieldTypeDeletedKeys, setFieldTypeDeletedKeys] = useState([]);
  const [patternRowData, setPatternRowData] = useState([]);
  const [patternGridApi, setPatternGridApi] = useState(null);
  const [patternDeletedKeys, setPatternDeletedKeys] = useState([]);

  const [constantRowData, setConstantRowData] = useState([]);
  const [constantGridApi, setConstantGridApi] = useState(null);
  const [constantDeletedKeys, setConstantDeletedKeys] = useState([]);

  const [reqRowData, setReqRowData] = useState([]);
  const [reqGridApi, setReqGridApi] = useState(null);
  const [reqDeletedKeys, setReqDeletedKeys] = useState([]);
  const [customizePasteLogic, setCustomizePasteLogic] = useState({});
  const [checkboxes, setCheckboxes] = useState({});
  const [buttonClicked, setButtonClicked] = useState(false);

 //grid related stuff
 const getfieldTypeGridApi = useCallback((api) => {
   setFieldTypeGridApi(api);
 }, []);

 const getPatternGridApi = useCallback((api) => {
   setPatternGridApi(api);
 }, []);

 const getConstantGridApi = useCallback((api) => {
   setConstantGridApi(api);
 }, []);

 const getReqGridApi = useCallback((api) => {
   setReqGridApi(api);
 }, []);
  const fieldTypeGridOptions = {
    columnDefs: [
      {
        showDeleteIconOnly: true,
        isDeleteControl: true,
        editable: false,
        suppressMovable: true,
        deleteHandler: (data) => {
          setFieldTypeDeletedKeys((prev) => [...prev, data]);
        },
        showDeleteIcon: (data) => {
          return data.value || data.fieldType;
        },
        headerClass: "first-column-header",
      },
      {
        headerName: t("COL_QUICK_FIELD_ADD_CUSTOMIZER_IF"),
        field: "value",
        editable: true,
        resizable: true,
      },
      {
        headerName: t("COL_QUICK_FIELD_ADD_CUSTOMIZER_THEN_FIELD_TYPE"),
        field: "fieldType",
        cellRenderer: CustomDropdownEditor,
        cellRendererParams: { values: currentScreen === 'outbound' ? outboundFieldTypeOptionsArray : fieldTypeOptionsArray },
        cellStyle: { margin: 0, padding: 0 },

        resizable: true,
      },
    ],
  };
  const patternGridOptions = {
    columnDefs: [
      {
        showDeleteIconOnly: true,
        isDeleteControl: true,
        editable: false,
        suppressMovable: true,
        deleteHandler: (data) => {
          setPatternDeletedKeys((prev) => [...prev, data]);
        },
        showDeleteIcon: (data) => {
          return data.value || data.pattern;
        },
        headerClass: "first-column-header",
      },
      {
        headerName: t("COL_QUICK_FIELD_ADD_CUSTOMIZER_IF"),
        field: "value",
        editable: true,
        resizable: true,
      },
      {
        headerName: t("COL_QUICK_FIELD_ADD_CUSTOMIZER_THEN_PATTERN"),
        field: "pattern",
        editable: true,
        resizable: true,
      },
    ],
  };
  const constantGridOptions = {
    columnDefs: [
      {
        showDeleteIconOnly: true,
        isDeleteControl: true,
        editable: false,
        suppressMovable: true,
        deleteHandler: (data) => {
          setConstantDeletedKeys((prev) => [...prev, data]);
        },
        showDeleteIcon: (data) => {
          return data.value || data.constVal;
        },
        headerClass: "first-column-header",
      },
      {
        headerName: t("COL_QUICK_FIELD_ADD_CUSTOMIZER_IF"),
        field: "value",
        editable: true,
        resizable: true,
      },
      {
        headerName: t("COL_QUICK_FIELD_ADD_CUSTOMIZER_THEN_CONSTANT"),
        field: "constVal",
        editable: true,
        resizable: true,
      },
    ],
  };
  const reqGridOptions = {
    columnDefs: [
      {
        showDeleteIconOnly: true,
        isDeleteControl: true,
        editable: false,
        suppressMovable: true,
        deleteHandler: (data) => {
          setReqDeletedKeys((prev) => [...prev, data]);
        },
        showDeleteIcon: (data) => {
          return data.value || data.chkVal;
        },
        headerClass: "first-column-header",
      },
      {
        headerName: t("COL_QUICK_FIELD_ADD_CUSTOMIZER_IF"),
        field: "value",
        editable: true,
        resizable: true,
      },
      {
        headerName: t("COL_QUICK_FIELD_ADD_CUSTOMIZER_THEN_REQUIRED"),
        field: "chkVal",
        editable: false,
        resizable: true,
      },
    ],
  };
  //If the 'value starts with' column contains any data, 
  // the corresponding 'apply this check' column will always have the value 'Y'
  function onReqCellValueChangedHandler(params) {
    if (params.colDef.field === 'value') {
      const rowData = params.data;
      rowData.chkVal = rowData.value ? 'Y' : '';
  
      // refresh the grid after updating the data
      params.api.refreshCells({ rowNodes: [params.node], force: true });
    }
  };
  
  // checkboxes in available columns tab
  const generateCheckboxes = () => {
    const chkBoxProps = [
      {
        name: t("LBL_FIELD_TYPE"),
        disabled: true,
        label: t("LBL_FIELD_TYPE"),
        checked: true,
      },
      ...(currentScreen === "inbound"
        ? [
            {
              name: t("TBL_FLD_NAME"),
              disabled: true,
              label: t("TBL_FLD_NAME"),
              checked: true,
            },
          ]
        : []),
      {
        name: t("DESCRIPTION"),
        disabled: true,
        label: t("DESCRIPTION"),
        checked: true,
      },
      ...(currentScreen === "outbound"
        ? [
            {
              name: "convertCase",
              disabled: false,
              label: t("LBL_CONVERT_CASE").replace(':',''),
              checked: checkboxes?.convertCase === "true",
              handleCheck: () => handleCheck("convertCase"),
            },
            {
              name: "paddingDirection",
              disabled: false,
              label: t("LBL_PAD_DIR").replace(':',''),
              checked: checkboxes?.paddingDirection === "true",
              handleCheck: () => handleCheck("paddingDirection"),
            },
            {
              name: "fillCharacter",
              disabled: false,
              label: t("LBL_FILL_CHAR").replace(':',''),
              checked: checkboxes?.fillCharacter === "true",
              handleCheck: () => handleCheck("fillCharacter"),
            },
          ]
        : []),
      {
        name: "precision",
        disabled: false,
        label: t("PRECISION"),
        checked: checkboxes?.precision === "true",
        handleCheck: () => handleCheck("precision"),
      },
      {
        name: "pattern",
        disabled: false,
        label: t("PATTERN"),
        checked: checkboxes?.pattern === "true",
        handleCheck: () => handleCheck("pattern"),
      },
      {
        name: "length",
        disabled: false,
        label: t("COL_LENGTH"),
        checked: checkboxes?.length === "true",
        handleCheck: () => handleCheck("length"),
      },
      ...(currentScreen === "outbound"
        ? [
            {
              name: "quoteData",
              disabled: false,
              label: t("BTN_QUOTE_DATA"),
              checked: checkboxes?.quoteData === "true",
              handleCheck: () => handleCheck("quoteData"),
            },
            {
              name: "trimData",
              disabled: false,
              label: t("BTN_TRIM_DATA"),
              checked: checkboxes?.trimData === "true",
              handleCheck: () => handleCheck("trimData"),
            },
            {
              name: "urlEncodeData",
              disabled: false,
              label: t("BTN_URLENCODE_DATA"),
              checked: checkboxes?.urlEncodeData === "true",
              handleCheck: () => handleCheck("urlEncodeData"),
            },
            {
              name: "suppressFieldDelimiter",
              disabled: false,
              label: t("LBL_SUPP_FLD_DELIM"),
              checked: checkboxes?.suppressFieldDelimiter === "true",
              handleCheck: () => handleCheck("suppressFieldDelimiter"),
            },
            {
              name: "addToWorkflowSession",
              disabled: false,
              label: t("BTN_WS_USE_IN_SESSION"),
              checked: checkboxes?.addToWorkflowSession === "true",
              handleCheck: () => handleCheck("addToWorkflowSession"),
            },
            {
              name: "constVal",
              disabled: false,
              label: t("CONSTANT_VALUE"),
              checked: checkboxes.constVal === "true",
              handleCheck: () => handleCheck("constVal"),
            },
          ]
        : []),
      {
        name: "req",
        disabled: false,
        label: t("IS_REQUIRED_DATA_VALIDATION"),
        checked: checkboxes?.req === "true",
        handleCheck: () => handleCheck("req"),
      },
      {
        name: "minLength",
        disabled: false,
        label: t("MIN_LENGTH_DATA_VAL"),
        checked: checkboxes?.minLength === "true",
        handleCheck: () => handleCheck("minLength"),
      },
      {
        name: "maxLength",
        disabled: false,
        label: t("MAX_LENGTH_DATA_VAL"),
        checked: checkboxes?.maxLength === "true",
        handleCheck: () => handleCheck("maxLength"),
      },
    ];

    const hl7ChkBoxProp = {
      name: "hl7DataType",
      disabled: false,
      label: t("LBL_HL7_DATA_TYPE"),
      checked: checkboxes?.hl7DataType === "true",
      handleCheck: () => handleCheck("hl7DataType"),
    };
    if (templateHeader.FILETYPE === "HL7") chkBoxProps.push(hl7ChkBoxProp);

    return chkBoxProps.map((props, index) => (
      <TPCheckbox
        key={index}
        name={props.name}
        label={props.label}
        disabled={props.disabled}
        checked={props.checked}
        handleCheck={(checked) =>
          handleCheck(props.name, checked)
        }></TPCheckbox>
    ));
  };
  const checkBoxComponents = generateCheckboxes();

  useEffect(() => {
    if (columns && typeof columns === "object") {
      setCheckboxes(columns);
    }
  }, [columns]);

  const handleCheck = (name, checked) => {
    setAvailableColumns({ ...columns, [name]: checked.toString() });
    setCustomizePasteLogic((prev) => ({
      ...prev,
      availableColumns: { ...checkboxes, [name]: checked.toString() },
    }));
  };
  // delimiter tab stuff
  useEffect(() => {
    setCustomizePasteLogic((prev) => ({
      ...prev,
      delimiter: {
        recordDelimter: quickAdd.recordDelim,
        fieldDelimiter: quickAdd.fieldDelim,
      },
    }));
  }, [quickAdd]);

  // post done button click action
  const handleDone = () => {
    const getGridData = (gridApi) => {
      const rowData = [];
      if (gridApi) {
        gridApi?.forEachNode((node) => {
          rowData.push(node.data);
        });
      }
      return rowData;
    };
    let fldTypeRowData = getGridData(fieldTypeGridApi);
    let constRowData = getGridData(constantGridApi);
    let requiredRowData = getGridData(reqGridApi);
    let patternTypeRowData = getGridData(patternGridApi);
    setAvailableColumns(columns);
    setCustomizePasteLogic((prev) => ({
      ...prev,
      fieldType: fldTypeRowData.length > 0 ? fldTypeRowData : prev.fieldType,
      pattern:  patternTypeRowData.length > 0 ? patternTypeRowData : prev.pattern,
      required: requiredRowData.length > 0 ? requiredRowData : prev.required,
      constVal: constRowData.length > 0 ? constRowData : prev.constVal,
    }));
    setButtonClicked(true);
  };

  const postCustomizePasteLogic = (customizePasteLogic) => {
    if (!checkboxes) return;
    
    function removeEmptyValues(obj) {
      const arraysToCheck = ['fieldType', 'pattern', 'constVal', 'required'];
      const result = {};
    
      for (const key in obj) {
        if (arraysToCheck.includes(key) && Array.isArray(obj[key])) {
          const filteredArray = obj[key]
            .filter((item) => !(Object.keys(item).length === 1 && item.hasOwnProperty('id')))
            .filter((item) => item.value !== '');
          result[key] = filteredArray;
        } else {
          result[key] = obj[key];
        }
      }
    
      return result;
    }
    if (checkboxes && quickAddModal && customizePasteLogic) {
      const pasteLogic = removeEmptyValues(customizePasteLogic)

      if (!_.isEqual(tabData, pasteLogic)) {
        setPasteLogicUpdated(true)
        dispatch(
          api.endpoints.processQuickAddCustomizeScreen.initiate(
            {
              template_type: currentScreen === "inbound" ? "in" : "out",
              hl7: templateHeader.FILETYPE === "HL7" ? "Y" : "N",
              data: pasteLogic,
            },
            { forceRefetch: true }
          )
        ).then((response) => {
          if (response.data.current_state === "SUCCESS") {
            setCustomizePasteLogic(response.data.data);
            setTabData(response.data.data);
          } else {
            console.log(response.message);
          }
        });
      }
    }
  };

 
  useEffect(() => {
    if (buttonClicked) {
      postCustomizePasteLogic(customizePasteLogic);
      setOpenCustomizeModal(false);
    }
  }, [customizePasteLogic, buttonClicked]);

  useEffect(() => {
    handleCustomizePasteLogic(customizePasteLogic);
  }, [customizePasteLogic]);

  // handle initial render
  useEffect(() => {
    if (quickAddModal && tabData) {
      setCustomizePasteLogic(tabData);

      const addNewRowWithId = (data, newItem) => {
        const dataWithId =
          data?.map((item, index) => ({
            id: index,
            ...item,
          })) || [];

        if (dataWithId.length > 0) {
          const newId = dataWithId.length;
          const newItemWithId = {
            id: newId,
            ...newItem,
          };

          return [...dataWithId, newItemWithId];
        }

        return [newItem];
      };

      const fieldTypeWithNewId = addNewRowWithId(tabData.fieldType, {
        value: "",
        fieldType: "",
      });
      const patternWithNewId = addNewRowWithId(tabData.pattern, {
        value: "",
        pattern: "",
      });
      const constValWithNewId = addNewRowWithId(tabData.constVal, {
        value: "",
        constVal: "",
      });
      const reqValWithNewId = addNewRowWithId(tabData.required, {
        value: "",
        chkVal: "",
      });

      setFieldTypeRowData(fieldTypeWithNewId);
      setPatternRowData(patternWithNewId);
      setConstantRowData(constValWithNewId);
      setReqRowData(reqValWithNewId);

      handleCustomizePasteLogic(customizePasteLogic);
    }
  }, [quickAddModal]);

  // handle accordian change 
  const handleChange = (panel) => (event, isExpanded) => {
    setPreviouslyExpanded(expanded);
    setExpanded(isExpanded ? panel : false); 
  };

  const handleUpdateCustomizePasteLogic = useCallback(() => {
    const getGridData = (gridApi) => {
      const rowData = [];
      if (gridApi) {
        gridApi?.forEachNode((node) => {
          rowData.push(node.data);
        });
      }
      return rowData;
    };

    let gridApiMapping = {
      fieldType: fieldTypeGridApi,
      pattern: patternGridApi,
      constVal: constantGridApi,
      required: reqGridApi,
    };

    let rowDataMapping = {
      fieldType: setFieldTypeRowData,
      pattern: setPatternRowData,
      constVal: setConstantRowData,
      required: setReqRowData,
    };

    const updateCustomizePasteLogic = (
      gridApi,
      property,
      setRowData
    ) => {
      if(gridApi!== undefined){
      const rowData = getGridData(gridApi);
      setAvailableColumns(columns);
      setRowData((prev) => (rowData.length > 0 ? rowData : prev));
      setCustomizePasteLogic((prev) => ({
        ...prev,
        [property]: rowData.length > 0 ? rowData : prev[property],
      }));
     }
    };

    if (
      previouslyExpanded === "fieldType" ||
      previouslyExpanded === "constVal" ||
      previouslyExpanded === "pattern" ||
      previouslyExpanded === "required" 
    ) {
      updateCustomizePasteLogic(
        gridApiMapping[previouslyExpanded],
        previouslyExpanded,
        rowDataMapping[previouslyExpanded]
      );
    }
  }, [expanded]);

useEffect(() => {
    handleUpdateCustomizePasteLogic();
}, [handleUpdateCustomizePasteLogic]);

  const handleBackdropClick = (event, reason) => {
    if (reason === "backdropClick") return;
  };


  return (
    <>
      <Drawer
        achor="left"
        open={open}
        onClose={() => setOpenCustomizeModal(false)}
        ModalProps={{
          onClose: handleBackdropClick,
        }}
        SlideProps={{
          style: { transform: open ? "translateX(0)" : "translateX(-240px)" },
        }}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            boxShadow: "none",
            overflow: "hidden",
          },
        }}>
        <div
          className="flex-column height-100"
          style={{
            backgroundColor: "#fff",
            position: "relative",
          }}>
          <div className="quick-add-container padding-16">
            <div style={{ lineHeight: "25px" }}>
              <p style={{ marginBottom: "10px" }}>
                {t("DIAG_QUICK_FIELD_ADD_CUSTOMIZER_TIT")}
              </p>
              <div className="font-12">
                <p>{t("DIAG_QUICK_FIELD_ADD_CUSTOMIZER_DESC")}</p>
              </div>
            </div>
          </div>
          <div style={{ padding: "16px", flex: 1 }}>
            <div
              style={{
                overflow: "auto",
                border: "solid 1px #eeeeee",
                borderRadius: "5px",
                borderTopRightRadius: "5px",
                height: "72vh",
              }}>
              <Accordion
                expanded={expanded === "availableColumns"}
                onChange={handleChange("availableColumns")}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header">
                  <Typography
                    sx={{ width: "53%", flexShrink: 0, fontWeight: 800 }}>
                    {`${t("TAB_AVAILABLE_COLUMNS")}:`}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    {t(
                      "LBL_QUICK_FIELD_ADD_CUSTOMIZE_DIALOG_AVAILABLE_COLUMNS_MESSAGE"
                    )}
                  </Typography>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    {checkBoxComponents}
                  </div>
                </AccordionDetails>
              </Accordion>
              <Accordion
                TransitionProps={{ unmountOnExit: true }}
                expanded={expanded === "delimiter"}
                onChange={handleChange("delimiter")}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2bh-content"
                  id="panel2bh-header">
                  <Typography
                    sx={{ width: "53%", flexShrink: 0, fontWeight: 800 }}>
                    {t("LBL_FILL_DELIM")}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    {t("LBL_QUICK_FIELD_ADD_CUSTOMIZE_DIALOG_DELIM_MESSAGE")}
                  </Typography>
                  <FormControl
                    className="width-100  margin-top-16"
                    size="small">
                    <ItemPropertiesDelimiterInput
                      label={t("RECORD_DELIMITER")}
                      value={recordDelimiterValue}
                      name={"recordDelim"}
                      source={"QUICK_ADD"}
                    />
                  </FormControl>
                  <FormControl className="width-100 margin-top-16" size="small">
                    <ItemPropertiesDelimiterInput
                      label={t("LBL_FLD_DELIM")}
                      value={fieldDelimiterValue}
                      name={"fieldDelim"}
                      source={"QUICK_ADD"}
                    />
                  </FormControl>
                </AccordionDetails>
              </Accordion>
              <Accordion
                TransitionProps={{ unmountOnExit: true }}
                expanded={expanded === "fieldType"}
                onChange={handleChange("fieldType")}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel3bh-content"
                  id="panel3bh-header">
                  <Typography
                    sx={{ width: "53%", flexShrink: 0, fontWeight: 800 }}>
                    {t("LBL_FLD_TYPE")}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <CommonGrid
                    rowData={fieldTypeRowData}
                    gridOptions={fieldTypeGridOptions}
                    containerClasses={"customize-grid-container"}
                    getGridAPI={getfieldTypeGridApi}
                    gridProps={{
                      suppressHorizontalScroll: true,
                      suppressScrollOnNewData: true,
                      suppressScrollWhenPopupsAreOpen: true,
                      animateRows: false,
                      enableCellTextSelection: true,
                      ensureDomOrder: true,
                      suppressClickEdit: true,
                    }}
                  />
                </AccordionDetails>
              </Accordion>
              <Accordion
                TransitionProps={{ unmountOnExit: true }}
                expanded={expanded === "pattern"}
                onChange={handleChange("pattern")}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4bh-content"
                  id="panel4bh-header">
                  <Typography
                    sx={{ width: "53%", flexShrink: 0, fontWeight: 800 }}>
                    {t("LBL_PATTERN")}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <CommonGrid
                    rowData={patternRowData}
                    gridOptions={patternGridOptions}
                    containerClasses={"customize-grid-container"}
                    getGridAPI={getPatternGridApi}
                    gridProps={{
                      suppressHorizontalScroll: true,
                      suppressScrollOnNewData: true,
                      suppressScrollWhenPopupsAreOpen: true,
                      animateRows: false,
                      enableCellTextSelection: true,
                      ensureDomOrder: true,
                      suppressClickEdit: true,
                    }}
                  />
                </AccordionDetails>
              </Accordion>
              {currentScreen === "outbound" && (
                <Accordion
                  TransitionProps={{ unmountOnExit: true }}
                  expanded={expanded === "constVal"}
                  onChange={handleChange("constVal")}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel5bh-content"
                    id="panel5bh-header">
                    <Typography
                      sx={{ width: "53%", flexShrink: 0, fontWeight: 800 }}>
                      {t("LBL_CONST_VAL")}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <CommonGrid
                      rowData={constantRowData}
                      gridOptions={constantGridOptions}
                      getGridAPI={getConstantGridApi}
                      containerClasses={"customize-grid-container"}
                      gridProps={{
                        suppressHorizontalScroll: true,
                        suppressScrollOnNewData: true,
                        suppressScrollWhenPopupsAreOpen: true,
                        animateRows: false,
                        enableCellTextSelection: true,
                        ensureDomOrder: true,
                        suppressClickEdit: true,
                      }}
                    />
                  </AccordionDetails>
                </Accordion>
              )}
              <Accordion
                TransitionProps={{ unmountOnExit: true }}
                expanded={expanded === "required"}
                onChange={handleChange("required")}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel6bh-content"
                  id="panel6bh-header">
                  <Typography
                    sx={{ width: "53%", flexShrink: 0, fontWeight: 800 }}>
                    {t("LBL_REQUIRED")}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <div className="font-12">
                    <p style={{ marginBottom: "5px" }}>
                      {t("LBL_ENTER_ONLY_CHECKED_VALUES")}
                    </p>
                  </div>
                  <CommonGrid
                    rowData={reqRowData}
                    gridOptions={reqGridOptions}
                    getGridAPI={getReqGridApi}
                    containerClasses={"customize-grid-container"}
                    
                    gridProps={{
                      suppressHorizontalScroll: true,
                      suppressScrollOnNewData: true,
                      suppressScrollWhenPopupsAreOpen: true,
                      animateRows: false,
                      enableCellTextSelection: true,
                      ensureDomOrder: true,
                      suppressClickEdit: true,
                      onCellValueChanged :onReqCellValueChangedHandler
                    }}
                  />
                </AccordionDetails>
              </Accordion>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              padding: "9px",
            }}>
            <FormControl>
              <Button
                variant="outlined"
                size="small"
                className="margin-right-4"
                onClick={handleDone}>
                {t("BTN_DONE")}
              </Button>
            </FormControl>
          </div>
        </div>
      </Drawer>
    </>
  );
}
export default CustomizeQuickFieldAdd;
